var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetanode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "600px",
    viewBox: "0 0 800 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MetaNode Blockchain Architecture") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 250,
    width: 200,
    height: 100,
    rx: 10,
    fill: "#EDE7F6",
    stroke: "#673AB7",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 300,
    fontFamily: "Arial",
    fontSize: 24,
    fill: "#673AB7",
    textAnchor: "middle"
  }, "Blockchain Core"), /*#__PURE__*/React.createElement("g", {
    id: "node1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 200,
    r: 40,
    fill: "#E1F5FE",
    stroke: "#03A9F4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 205,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#03A9F4",
    textAnchor: "middle"
  }, "Node 1")), /*#__PURE__*/React.createElement("g", {
    id: "node2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 400,
    r: 40,
    fill: "#E1F5FE",
    stroke: "#03A9F4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 405,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#03A9F4",
    textAnchor: "middle"
  }, "Node 2")), /*#__PURE__*/React.createElement("g", {
    id: "node3"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 200,
    r: 40,
    fill: "#E1F5FE",
    stroke: "#03A9F4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 205,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#03A9F4",
    textAnchor: "middle"
  }, "Node 3")), /*#__PURE__*/React.createElement("g", {
    id: "node4"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 630,
    cy: 400,
    r: 40,
    fill: "#E1F5FE",
    stroke: "#03A9F4",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 630,
    y: 405,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#03A9F4",
    textAnchor: "middle"
  }, "Node 4")), /*#__PURE__*/React.createElement("g", {
    id: "vpod1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 150,
    width: 100,
    height: 60,
    rx: 5,
    fill: "#E8F5E9",
    stroke: "#4CAF50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 185,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#4CAF50",
    textAnchor: "middle"
  }, "vPod Container")), /*#__PURE__*/React.createElement("g", {
    id: "vpod2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 390,
    width: 100,
    height: 60,
    rx: 5,
    fill: "#E8F5E9",
    stroke: "#4CAF50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 300,
    y: 425,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#4CAF50",
    textAnchor: "middle"
  }, "vPod Container")), /*#__PURE__*/React.createElement("g", {
    id: "vpod3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 150,
    width: 100,
    height: 60,
    rx: 5,
    fill: "#E8F5E9",
    stroke: "#4CAF50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 185,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#4CAF50",
    textAnchor: "middle"
  }, "vPod Container")), /*#__PURE__*/React.createElement("g", {
    id: "vpod4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 390,
    width: 100,
    height: 60,
    rx: 5,
    fill: "#E8F5E9",
    stroke: "#4CAF50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 500,
    y: 425,
    fontFamily: "Arial",
    fontSize: 14,
    fill: "#4CAF50",
    textAnchor: "middle"
  }, "vPod Container")), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 200,
    x2: 250,
    y2: 180,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 400,
    x2: 250,
    y2: 420,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 590,
    y1: 200,
    x2: 550,
    y2: 180,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 590,
    y1: 400,
    x2: 550,
    y2: 420,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 180,
    x2: 400,
    y2: 250,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350,
    y1: 420,
    x2: 400,
    y2: 350,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 180,
    x2: 400,
    y2: 250,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450,
    y1: 420,
    x2: 400,
    y2: 350,
    stroke: "#333",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 80,
    width: 300,
    height: 40,
    rx: 20,
    fill: "#FFF8E1",
    stroke: "#FFC107",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 105,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#FFC107",
    textAnchor: "middle"
  }, "Ethereum-grade Security Layer"), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 480,
    width: 300,
    height: 40,
    rx: 20,
    fill: "#F3E5F5",
    stroke: "#9C27B0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 505,
    fontFamily: "Arial",
    fontSize: 16,
    fill: "#9C27B0",
    textAnchor: "middle"
  }, "dApp Integration Layer"), /*#__PURE__*/React.createElement("path", {
    d: "M200,250 C250,280 300,320 400,300 C500,280 550,250 600,250",
    stroke: "#673AB7",
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: "5,5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200,350 C250,320 300,280 400,300 C500,320 550,350 600,350",
    stroke: "#673AB7",
    strokeWidth: 2,
    fill: "none",
    strokeDasharray: "5,5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetanode);
export default __webpack_public_path__ + "static/media/metanode.ba6af49b9f56f2f5e9b501ac46453141.svg";
export { ForwardRef as ReactComponent };